import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { finaliseRequest } from './utils';

export default function* listenFinaliseRequest() {
  yield takeEvery(basketActions.finaliseRequest.toString(), finaliseRequest);
}
